import * as Types from '../../../../../../../generated/base-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type LoadExamCandidatesQueryVariables = Types.Exact<{
  examId: Types.Scalars['ID'];
}>;


export type LoadExamCandidatesQuery = { __typename?: 'Query', exam: { __typename?: 'Exam', id: string, candidates: Array<{ __typename?: 'Candidate', id: number, omr: number, scrambling: number, reg_number: string, first_name: string, last_name: string, language: string, location: string, room?: string | null, email?: string | null, phone_number?: string | null, tags?: Array<string> | null, successful: boolean, provision_failed: boolean, destroy_failed: boolean }> } };

export const LoadExamCandidatesDocument = gql`
    query LoadExamCandidates($examId: ID!) {
  exam(id: $examId) {
    id
    candidates {
      id
      omr
      scrambling
      reg_number
      first_name
      last_name
      language
      location
      room
      email
      phone_number
      tags
      successful
      provision_failed
      destroy_failed
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadExamCandidatesGQL extends Apollo.Query<LoadExamCandidatesQuery, LoadExamCandidatesQueryVariables> {
    document = LoadExamCandidatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }